import { useState } from "react";
import { FleetrifyBgs } from "../../../assets/video";
import { FLEETRIFYROUTEPATH } from "../../../routes/routesPath";
import { useNavigate } from "react-router-dom";
import CarouselCard from "../../../components/Carousel";
import { useGetAccountTypesQuery } from "../../../redux/services/authApi";

const SignUp = () => {
  const navigate = useNavigate();
  const [showComingSoon, setShowComingSoon] = useState(false);
  const { data: accountTypes = [] } = useGetAccountTypesQuery();

  const slides = [
    { title: "Welcome to Fleetrify", description: "Login to manage logistics and fleet operations" },
    { title: "Real-time Fleet Insights", description: "Get live updates and analytics on every vehicle in your fleet" },
    { title: "Simplify Logistics Management", description: "Automate routing, tracking, and reporting — all in one platform" },
  ];

  const handleAccountType = (typeName: string) => {
    const match = accountTypes.find(
      (t) => t.name.toLowerCase() === typeName.toLowerCase()
    );
    if (!match) return;
    navigate(FLEETRIFYROUTEPATH.CREATE_ACCOUNT, {
      state: { account_type_id: match.id, account_type: typeName.toLowerCase() },
    });
  };

  return (
    <div className="relative flex flex-col lg:flex-row min-h-screen items-center justify-center lg:bg-transparent bg-gray-100">
      {/* video section */}
      <div className="relative w-full lg:w-[45%] h-screen lg:h-screen order-2 lg:order-none">
        <video className="absolute inset-0 w-full h-full object-cover" autoPlay muted loop playsInline>
          <source src={FleetrifyBgs} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>
        <div className="absolute z-20 inset-0 flex items-center justify-center">
          <CarouselCard slides={slides} />
        </div>
      </div>

      {/* account type section */}
      <div className="w-full lg:w-[55%] flex justify-center items-center absolute lg:static z-30 px-5 top-0 bottom-0 my-auto">
        <div className="w-[430px] sm:w-[340px] md:w-[500px] lg:w-[430px] max-w-full bg-white px-4 py-6 rounded">
          <div className="space-y-6">
            <div className="space-y-2 text-center">
              <h2 className="text-2xl font-bold text-[#143887]">Create an Account</h2>
              <p className="text-md text-center mb-8">Select your account type to continue with onboarding</p>
            </div>
            <div className="flex flex-col space-y-4">
              <button
                className="w-full py-3 px-4 border border-gray-500 rounded-md text-gray-800 hover:bg-gray-100 transition"
                onClick={() => handleAccountType("individual")}
              >
                Individual
              </button>

              {/* Organisation — disabled with coming soon modal trigger */}
              <button
                className="w-full py-3 px-4 border border-gray-300 rounded-md text-gray-400 bg-gray-50 cursor-not-allowed transition relative"
                disabled
                onClick={() => setShowComingSoon(true)}
              >
                Organisation
                <span className="ml-2 text-xs bg-gray-200 text-gray-500 px-2 py-0.5 rounded-full">
                  Coming Soon
                </span>
              </button>

              <div className="flex items-start gap-2 bg-blue-50 border border-blue-200 rounded-md px-3 py-2.5 text-xs text-blue-800">
                <span className="mt-0.5 text-blue-500 shrink-0">ℹ️</span>
                <p>
                  <span className="font-semibold">Important:</span> Please register with your <span className="font-semibold">real name</span> as it appears on your government-issued ID. This is required to successfully pass the KYC (Know Your Customer) verification during onboarding.
                </p>
              </div>

              <div className="text-xs text-[#4F4F4F] mb-3 text-center">
                Already have an account?{" "}
                <button
                  className="text-[#2F80ED] font-medium hover:underline"
                  onClick={() => navigate(FLEETRIFYROUTEPATH.LOGIN)}
                >
                  Sign In
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Coming Soon Modal */}
      {showComingSoon && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
          onClick={() => setShowComingSoon(false)}
        >
          <div
            className="bg-white rounded-xl shadow-lg px-8 py-7 w-[300px] text-center space-y-3"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-3xl">🚀</div>
            <h3 className="text-base font-semibold text-[#143887]">Coming Soon</h3>
            <p className="text-sm text-gray-500">
              Organisation accounts are not available yet. Stay tuned!
            </p>
            <button
              className="mt-2 px-5 py-2 bg-[#143887] text-white text-sm rounded-lg hover:bg-blue-800 transition"
              onClick={() => setShowComingSoon(false)}
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignUp;